import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { formatterDate, IVActivityTypeOptionsCodes, IVTypeOptions, optionsFormatter, PACVisitingModeOptions, tipoAttivitaOptions, tipoAttivitaOptionsCodes } from "../../../utils"
import { InspectionVisitDTO, InspectionVisitUpdateDTO } from "../dataservice/dto"
import { GetAllInspectionVisit, InspectionVisitDelete, resetInspectionVisitCreationStatus, resetInspectionVisitDeleteStatus, resetInspectionVisitRequest, resetRCAUpdateSatus, setInspectionVisitIdToUpdate, setInspectionVisitUpdateRequest, setIVToDelete, setIVUploadedFileId, setRCAIVCustomerId, setRCAIVId } from "../slice"
import { MagnifyingIcon } from "../../../ui/icons/magnifying"
import Button from "../../../ui/molecules/button"
import { RoundedPlusIcon } from "../../../ui/icons/RoundedPlusIcon"
import { useNavigate } from "react-router-dom"
import { EntryIcon } from "../../../ui/icons/entryIcon"
import { TrashIcon } from "../../../ui/icons/trash"
import { InspectionValIcon } from "../../../ui/icons/InspectionValIcon"
import { Alert } from "../../../ui/organisms/alert"
import { ActivityIcon } from "../../../ui/icons/activity"
import { ResultControlActivityEdit } from "./resultControlActivity/editPopup"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { handlePeriodicity } from "../../gestioneControllo/pac/utils"

export function InspectionVisitList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const [showPopupAdd, setShowPopupAdd] = useState<boolean>(false)
    const [showAlertDelete, setShowAlertDelete] = useState<boolean>(false)
    const [showPopupActivity, setShowPopupActivity] = useState<boolean>(false)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    const onEditHandle = (iv: InspectionVisitDTO) => {
        dispatch(setInspectionVisitIdToUpdate(iv.id))
        dispatch(setIVUploadedFileId(iv.fileId))
        dispatch(setInspectionVisitUpdateRequest({
            type: iv.type,
            mode: iv.mode,
            expirationDate: iv.expirationDate,
            expirationDateExtended: iv.expirationDateExtended,
            licenseeOperator: iv.licenseeOperator,
            controlDetail: iv.controlDetail,
            specification: iv.specification,
            bioNotificationId: iv.bioNotificationId !== null ? iv.bioNotificationId : undefined,
            ggNotificationId: iv.ggNotificationId !== null ? iv.ggNotificationId : undefined,
            sqnpiNotificationId: iv.sqnpiNotificationId !== null ? iv.sqnpiNotificationId : undefined,
            plannedVisitDate: iv.plannedVisitDate,
            effectiveVisitDate: iv.effectiveVisitDate,
            reportProtocolId: iv.reportProtocolId !== null ? iv.reportProtocolId : undefined,
            inLocoControl: iv.inLocoControl,
            documentalControl: iv.documentalControl,
            remoteVisit: iv.remoteVisit,
            remoteVisitProtocolId: iv.remoteVisitProtocolId !== null ? iv.remoteVisitProtocolId : undefined,
            inMoreDays: iv.inMoreDays,
            daysNumber: iv.daysNumber,
            startingEndingVisits: iv.startingEndingVisits !== null ? iv.startingEndingVisits : [],
            visitDate: iv.visitDate,
            result: iv.result,
            nonComplianceType: iv.nonComplianceType,
            instructorNote: iv.instructorNote,
            isRevoked: iv.isRevoked,
            revokedProtocolId: iv.revokedProtocolId !== null ? iv.revokedProtocolId : undefined,
            isNotPerformed: iv.isNotPerformed,
            exclusionProtocolId: iv.exclusionProtocolId !== null ? iv.exclusionProtocolId : undefined,
            exclusionDate: iv.exclusionDate,
            isReportReturned: iv.isReportReturned,
            restitutionProtocolId: iv.restitutionProtocolId !== null ? iv.restitutionProtocolId : undefined,
            returnedReportProtocolId: iv.returnedReportProtocolId !== null ? iv.returnedReportProtocolId : undefined,
            administrativeVerification: iv.administrativeVerification,
            note: iv.note,
            materialType: iv.materialType,
            plannedSampling: iv.plannedSampling,
            firstEnvelope: iv.firstEnvelope,
            secondEnvelope: iv.secondEnvelope,
            thirdEnvelope: iv.thirdEnvelope,
            fourthEnvelope: iv.fourthEnvelope,
            auditedActivities: iv.auditedActivities !== null ? iv.auditedActivities : [],
            activity: iv.activity,
            activityTypes: iv.activityTypes !== null ? iv.activityTypes : [],
            addOnIds: iv.addOnIds !== null ? iv.addOnIds : [],
            ggLotNumber: iv.ggLotNumber,
            ggControlDuration: iv.ggControlDuration,
            ggProducts: iv.ggProducts,
            ggTeamLeader: iv.ggTeamLeader,
            ggInspector: iv.ggInspector,
            ggObserver: iv.ggObserver,
            ggExpert: iv.ggExpert,
            sqnpiControlActivities: iv.sqnpiControlActivities !== null ? iv.sqnpiControlActivities : [],
            inSupportSubject: iv.inSupportSubject,
            inSupportSubjectEntity: iv.inSupportSubjectEntity,
            inAccompanyingSubject: iv.inAccompanyingSubject,
            inAccompanyingSubjectEntity: iv.inAccompanyingSubjectEntity,
            expertSubject: iv.expertSubject,
            traineeTechnician: iv.traineeTechnician,
        } as InspectionVisitUpdateDTO))
        navigate('/ivEdit')
    }

    useEffect(() => {
        dispatch(GetAllInspectionVisit({
            itemsPerPage: 0,
            page: 0,
            assignmentId: assignmentState.assignmentIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (assignmentState.inspectionVisitCreationStatus === 'successfully') {
            dispatch(GetAllInspectionVisit({
                itemsPerPage: 0,
                page: 0,
                assignmentId: assignmentState.assignmentIdToUpdate
            }))
        }
    }, [assignmentState.inspectionVisitCreationStatus])


    useEffect(() => {
        if (assignmentState.inspectionVisitDeleteStatus === 'successfully') {
            setShowAlertDelete(false)
            dispatch(resetInspectionVisitDeleteStatus())
            dispatch(GetAllInspectionVisit({
                itemsPerPage: 0,
                page: 0,
                assignmentId: assignmentState.assignmentIdToUpdate
            }))
        }
    }, [assignmentState.inspectionVisitDeleteStatus])

    useEffect(() => {
        if (assignmentState.rcaUpdateStatus === 'successfully') {
            dispatch(resetRCAUpdateSatus())
            setShowSuccess(true)
        }
    }, [assignmentState.rcaUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                showSuccess &&
                <div className="gap-[8px] text-left" style={{ margin: '24px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="text-left" style={{ padding: '0px 24px 0px 24px' }}>
                <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Elenco Controlli</span>
            </div>

            <div style={{ padding: '24px' }}>
                <table id="users-table" className="w-[100%]">
                    <thead className="h-[40px] uppercase">
                        <tr>
                            <th style={{ borderTopLeftRadius: '8px' }}></th>
                            <th className="width-[130px]">Sede</th>
                            <th className="width-[130px]">Cliente</th>
                            <th className="width-[70px]">Codice</th>
                            <th className="width-[130px]">Attività</th>
                            <th className="width-[130px]">Attività Oggetto Controllo</th>
                            <th className="width-[130px]">Tipo Controllo</th>
                            <th className="width-[130px]">Modalità Controllo</th>
                            <th className="width-[130px]">Periodo Controllo</th>
                            <th className="width-[130px]">Data Scadenza</th>
                            <th className="width-[130px]">Data Scadenza Prorogata</th>
                            <th className="width-[130px]">Data Controllo</th>
                            <th className="width-[130px]">Protocollo Controllo</th>
                            <th className="width-[130px]">Verifica Amministrativa</th>
                            <th className="width-[130px]">Costo Controllo</th>
                            <th className="width-[130px]">Stato Aggiornamento Ispettore</th>
                            <th className="width-[130px]" style={{ borderTopRightRadius: '8px', width: '40px' }}>Valutazione Ispettore</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            assignmentState.getAllInspectionVisitResponse?.data.map((iv, index) =>
                                <tr
                                    key={index}
                                    style={{
                                        color: '#4D797F',
                                        background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                    }}
                                >
                                    <td>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            <button onClick={() => onEditHandle(iv)} className="tooltip-container">
                                                <EntryIcon color={"orange"} size={28} />
                                                <span className="tooltip-text">Apri Visita</span>
                                            </button>
                                            <button onClick={() => {
                                                dispatch(setRCAIVId(iv.id))
                                                dispatch(setRCAIVCustomerId(iv.customerId))
                                                setShowPopupActivity(true)
                                            }} className="tooltip-container">
                                                <ActivityIcon color={"#314d51"} size={28} />
                                                <span className="tooltip-text">Apri Attività</span>
                                            </button>
                                            <button className="tooltip-container" onClick={
                                                () => {
                                                    dispatch(setIVToDelete({
                                                        idIvToDelete: iv.id,
                                                        companyName: iv.customerCompanyName
                                                    }))
                                                    setShowAlertDelete(true)
                                                }
                                            }>
                                                <TrashIcon color={"red"} size={24} />
                                                <span className="tooltip-text">Elimina Visita</span>
                                            </button>
                                        </div>
                                    </td>
                                    <td>{assignmentState.getAssignmentByIdResponse?.departureProtocolHeadQuarter}</td>
                                    <td>{iv.customerCompanyName}</td>
                                    <td>{iv.customerClientCode}</td>
                                    <td>{optionsFormatter(iv.activity, tipoAttivitaOptionsCodes)!} {
                                        iv.activityTypes.map((actType) => {
                                            return <span key={actType}>{optionsFormatter(actType, IVActivityTypeOptionsCodes)!} </span>;
                                        })
                                    }</td>
                                    <td>
                                        {/* {optionsFormatter(iv.activityTypes, IVActivityTypeOptionsCodes)!} */}
                                    </td>

                                    <td>
                                        {optionsFormatter(iv.type, IVTypeOptions)!} </td>
                                    <td>
                                        {optionsFormatter(iv.mode, PACVisitingModeOptions)!}

                                    </td>
                                    <td>{iv.annualControlPlaneDetailPeriodicity && handlePeriodicity(iv.annualControlPlaneDetailPeriodicity)}</td>
                                    <td>{formatterDate(iv.expirationDate)}</td>
                                    <td>{formatterDate(iv.expirationDateExtended)}</td>
                                    <td>{formatterDate(iv.effectiveVisitDate)}</td>
                                    <td>prot contr</td>
                                    <td>ver amm</td>
                                    <td>costo</td>
                                    <td>stato</td>
                                    <td><InspectionValIcon /></td>
                                </tr>
                            )}
                    </tbody>
                </table>
                {
                    (showAlertDelete) && (
                        <Alert title="Conferma operazione" close={() => setShowAlertDelete(false)} headerGreen={true}>
                            <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="pb-3 mt-4">
                                    <div>
                                        Sei sicuro di voler eliminare la visita di <b>{assignmentState.inspectionVisitToDelete.companyName}</b>?
                                    </div>
                                </div>
                                <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button
                                        variant="outline"
                                        color="dimgrey"
                                        iconPosition="off"
                                        label="Chiudi finestra"
                                        size="md"
                                        onClick={() => setShowAlertDelete(false)}
                                    />

                                    <div className="pl-8">
                                        <Button
                                            variant="solid"
                                            color={'red'}
                                            iconPosition="off"
                                            label={'Elimina'}
                                            size="md"
                                            onClick={() => {
                                                dispatch(InspectionVisitDelete(assignmentState.inspectionVisitToDelete.idIvToDelete))
                                            }
                                            }
                                        />
                                    </div>
                                </div>

                            </div>
                        </Alert>
                    )
                }

                {
                    showPopupActivity && (
                        <PopupForm headerGreen title="Attività di Controllo e Valutazione" close={() => setShowPopupActivity(false)}>
                            <ResultControlActivityEdit close={() => setShowPopupActivity(false)} />
                        </PopupForm>
                    )
                }
            </div>
        </div>
    )
}